import add from '@iconify/icons-ic/add';
import { Icon } from '@iconify/react';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  InputAdornment,
  Grid,
  Autocomplete,
  TextField
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { BiCloudDownload } from 'react-icons/bi';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import searchFill from '@iconify/icons-eva/search-fill';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { RootStyle, SearchStyle } from '../Global/Styling';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import { getBankDropdownData } from '../../store/Slice/Global/GlobalSlice';

export default function SalesToolbar({
  parent,
  selectStatus,
  setSelectStatus,
  handleDownloadMatchDetails,
  setDownloadPopup,
  downloadPopup,
  filterName,
  onFilterName,
  filterParameter,
  setFilterParameter
}) {
  // const [downloadPopup, setDownloadPopup] = useState(false);
  const [isOpenFilter, setOpenFilter] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { LoginData } = useLoginSelector();
  const { MasterTypeListDrop, BankDrop } = useGlobalSelector();

  const handleRemoveFilter = (e) => {
    setSelectStatus(' ');
    setFilterParameter((pre) => ({
      ...pre,
      bankId: null
    }));
  };
  const handleStatusChange = (event, newValue) => {
    setSelectStatus(newValue);
  };

  const getBankDropApi = useCallback(() => {
    if (!LoginData) return;
    const data = { companyId: LoginData?.companyId, userId: LoginData?.userId };
    dispatch(getBankDropdownData(data));
  }, [LoginData]);

  useEffect(() => {
    getBankDropApi();
  }, [getBankDropApi]);

  return (
    <>
      {isOpenFilter && (
        <Box sx={{ pt: 2 }}>
          <Grid
            container
            style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}
            spacing={3}
          >
            <Grid item size={{ md: 6, sm: 6, xs: 12 }}>
              {' '}
            </Grid>
            <Grid item size={{ md: 4, sm: 6, xs: 12 }} sx={{ minWidth: 200 }}>
              <Autocomplete
                id="combo-box-demo2"
                options={BankDrop || []}
                size="small"
                getOptionLabel={(option) => option.label || ''}
                renderOption={(props, option) => <li {...props}>{option.label}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select Bank" />
                )}
                value={BankDrop?.find((item) => item.value === filterParameter?.bankId) || null}
                onChange={(e, newValue) => {
                  // handleBranchDetails(newValue);
                  setFilterParameter((pre) => ({
                    ...pre,
                    bankId: newValue?.value
                  }));
                }}
              />
            </Grid>

            <Grid item size={{ md: 2, sm: 6, xs: 12 }}>
              <Tooltip title="Reset Filter">
                <IconButton onClick={(e) => handleRemoveFilter(e)} size="small">
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}
      <RootStyle
        sx={{
          borderBottom: '1px solid #eaedf1',
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            width: '100%!important',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tabs
              value={selectStatus}
              onChange={handleStatusChange}
              className="tabOuter"
              aria-label="status tabs"
              classes={{ indicator: 'tabIndicator' }}
            >
              {MasterTypeListDrop?.length > 0 &&
                MasterTypeListDrop?.map((item) => (
                  <Tab
                    key={item.value}
                    label={item.label}
                    value={item.value}
                    classes={{ selected: 'tabSelected', root: 'tabDefault' }}
                  />
                )).reverse()}
            </Tabs>
            <Tooltip
              title={`Download ${selectStatus === 260 ? 'Mis matched' : 'Matched'} Report`}
              placement="top"
              arrow
            >
              <IconButton
                classes={{ disabled: 'disabledBtn' }}
                className="squareIconButton"
                onClick={(e) => setDownloadPopup(true)}
              >
                <BiCloudDownload size={18} />
              </IconButton>
            </Tooltip>
          </Box>
          &nbsp;&nbsp;&nbsp;
          <Box>
            <SearchStyle
              value={filterName}
              onChange={onFilterName}
              placeholder="Search Sales"
              classes={{
                root: 'searchHolder',
                input: 'searchInput'
              }}
              startAdornment={
                <InputAdornment position="start">
                  <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
                </InputAdornment>
              }
            />
            <Tooltip title="Filter list">
              <IconButton
                onClick={(e) => {
                  if (isOpenFilter) {
                    setOpenFilter(false);
                  } else {
                    setOpenFilter(true);
                  }
                }}
              >
                <Icon icon={roundFilterList} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        {/* Download pop up start */}
        <Dialog
          className="PopupBox"
          open={downloadPopup}
          onClose={(e) => setDownloadPopup(false)}
          fullWidth
        >
          <DialogTitle className="popupTitle">
            <Typography variant="h6">Download</Typography>
            <IconButton onClick={(e) => setDownloadPopup(false)} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Typography variant="body2">
              Are you sure you want to download {selectStatus === 260 ? 'Mis matched' : 'Matched'}{' '}
              details report?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDownloadMatchDetails} variant="contained" className="mainBtn">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </RootStyle>
    </>
  );
}
